import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";

const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const MAP_ID = "sbs-properties-map";
const MOMBASA = { lat: -4.0435, lng: 39.6682 };

export const PropertyMap = ({
  lat = MOMBASA.lat,
  lng = MOMBASA.lng,
  markers = null,
  onPick = null,
  height = "420px",
  zoom = 15,
}) => {
  if (!MAPS_KEY) {
    const q = markers && markers.length ? `${markers[0].lat},${markers[0].lng}` : `${lat},${lng}`;
    return (
      <iframe
        title="Property location map"
        data-testid="property-map-embed"
        src={`https://www.google.com/maps?q=${q}&z=${zoom}&output=embed`}
        style={{ width: "100%", height }}
        className="border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    );
  }
  const pins = markers && markers.length ? markers : [{ lat, lng }];
  return (
    <div data-testid="property-map-container" style={{ height }} className="w-full overflow-hidden">
      <APIProvider apiKey={MAPS_KEY}>
        <Map
          defaultCenter={{ lat, lng }}
          defaultZoom={zoom}
          mapId={MAP_ID}
          gestureHandling="greedy"
          disableDefaultUI
          zoomControl
          onClick={onPick ? (e) => onPick(e.detail.latLng) : undefined}
        >
          {pins.map((m, i) => (
            <AdvancedMarker key={m.id || i} position={{ lat: Number(m.lat), lng: Number(m.lng) }} title={m.title || ""} />
          ))}
        </Map>
      </APIProvider>
    </div>
  );
};
